import { c as _c } from "react/compiler-runtime";
import { useLandingPageModal } from '@/components/flow/nodes/LandingPageNode/store/useLandingPageModal';
import { useBoardNodeFullscreenActive } from '@/hooks/useBoardNodeFullscreenActive';
import { setSupportChatHidden } from '@/lib/supportChat';
import { useCanvasOverlayStore } from '@/stores/useCanvasOverlayStore';
import { useSidePanelStore } from '@/stores/useSidePanelStore';
import { usePathname } from 'next/navigation';

/** Shared suppression for the support chat, TanStack Query devtools, Next.js dev indicator, etc. */
export function applyBoardChromeSuppression(suppressed: boolean) {
  document.documentElement.classList.toggle('board-node-fullscreen', suppressed);
  setSupportChatHidden(suppressed);
}
export function useBoardChromeSuppressed() {
  const $ = _c(2);
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    t0 = pathname.startsWith("/vault");
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isVaultScreen = t0;
  const isNodeFullscreen = useBoardNodeFullscreenActive();
  const isWebsiteEditorOpen = useLandingPageModal(_temp);
  const isSidePanelOpen = useSidePanelStore(_temp2);
  const isBoardDropTargetActive = useCanvasOverlayStore(_temp3);
  return isVaultScreen || isNodeFullscreen || isWebsiteEditorOpen || isSidePanelOpen || isBoardDropTargetActive;
}
function _temp3(state_1) {
  return state_1.isBoardDropTargetActive;
}
function _temp2(state_0) {
  return state_0.isOpen;
}
function _temp(state) {
  return state.landingPageModal.show;
}